import { DcfSdkEnumsObj } from "../../enums/DcfSdkEnum";
import { MastercardConsumerMapper } from "./mappers/MastercardConsumerMapper";
import { VisaConsumerMapper } from "./mappers/VisaConsumerMapper";
export var mapConsumerForNetwork = function (cardBrand, consumer, billingAddressCountryCode, useNetworkValidationProfile) {
    if (useNetworkValidationProfile === void 0) { useNetworkValidationProfile = false; }
    switch (cardBrand) {
        case DcfSdkEnumsObj.VISA:
            return {
                cardBrand: DcfSdkEnumsObj.VISA,
                result: VisaConsumerMapper.map(consumer, { billingAddressCountryCode: billingAddressCountryCode, useNetworkValidationProfile: useNetworkValidationProfile }),
            };
        case DcfSdkEnumsObj.MASTERCARD:
            return {
                cardBrand: DcfSdkEnumsObj.MASTERCARD,
                result: MastercardConsumerMapper.map(consumer, { billingAddressCountryCode: billingAddressCountryCode, useNetworkValidationProfile: useNetworkValidationProfile }),
            };
        default:
            return undefined;
    }
};
export var toMappedConsumerPayment = function (selectedMapping, encryptedCard, rememberMe) {
    if (!selectedMapping.result.value) {
        return undefined;
    }
    if (selectedMapping.cardBrand === DcfSdkEnumsObj.VISA) {
        return {
            cardBrand: DcfSdkEnumsObj.VISA,
            encryptedCard: encryptedCard,
            consumer: selectedMapping.result.value,
            rememberMe: rememberMe,
        };
    }
    return {
        cardBrand: DcfSdkEnumsObj.MASTERCARD,
        encryptedCard: encryptedCard,
        consumer: selectedMapping.result.value,
        rememberMe: rememberMe,
    };
};
export var toRecognizedAddCardPayment = function (selectedMapping, encryptedCard, idToken) {
    if (!selectedMapping.result.value) {
        return undefined;
    }
    if (selectedMapping.cardBrand === DcfSdkEnumsObj.VISA) {
        return {
            cardBrand: DcfSdkEnumsObj.VISA,
            encryptedCard: encryptedCard,
            consumer: selectedMapping.result.value,
            idToken: idToken,
        };
    }
    return {
        cardBrand: DcfSdkEnumsObj.MASTERCARD,
        encryptedCard: encryptedCard,
        consumer: selectedMapping.result.value,
        idToken: idToken,
    };
};
